<template>
  <b-card class="bg-gray mt-4" border-variant="left-decorated">
    <b-row v-if="item">
      <b-col cols="12" md="3">
        <CustomInputDisplay
          label="Centro:"
          :value="item.center && item.center.name"
        />
      </b-col>
      <b-col cols="12" md="3">
        <CustomInputDisplay
          label="Municipio:"
          :value="item.municipality && item.municipality.name"
        />
      </b-col>
      <b-col cols="12" md="3">
        <CustomInputDisplay
          label="Escuela:"
          :value="item.school && item.school.name"
        />
      </b-col>
      <b-col
        cols="12"
        class="d-flex align-items-center justify-content-end"
        md="3"
      >
        <ActionButton
          text="Entrar"
          i="fas fa-file-import fa-fw"
          variant="outline-success"
          class="px-4"
          @click="
            $router.push({
              name: 'location-alternatives-manage',
              params: {
                schoolId: item.school && item.school.id,
                academicYearId: item.academicYear && item.academicYear.id,
              },
            })
          "
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import CustomInputDisplay from 'CustomInputDisplay';
import ActionButton from 'ActionButton';

export default {
  name: 'LocationAlternativesSearchResultItem',
  components: { CustomInputDisplay, ActionButton },
  props: {
    item: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.border-left-decorated {
  border: none;
  border-left: 0.25rem solid #e2e2e2;
}
</style>
